import React, { useState, useContext, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useHistory } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import { styled } from "@mui/material/styles";
import { isMobile } from "react-device-detect";

import AuthContext from "../../auth/context";

import Header from "../../components/header/Header";
import MenuSide from "../../components/menu/MenuSide";

import Unidades from "../../routes/unidade";
import Ranking from "../../routes/ranking";
import Perfil from "../../routes/perfil/Perfil";
import Escola from "../../routes/perfil/SelecaoCiclo";
import AlteracaoSenha from "../../routes/perfil/AlteracaoSenha";

// import Unidades from '../../routes/unidade/Unidades';
// import Home from '../../routes/Home';
// // import Componentes from '../../routes/components/index';
// import FormularioExemplo from '../../routes/formulario-exemplo';
// import Escolas from '../../routes/escolas';
// import Atributos from '../../routes/atributos';
// import Perfis from '../../routes/perfis';
// import Dashboard from '../../routes/dashboard';
// import VisaoGeral from '../../routes/visao-geral';
// import VisaoDecisao from '../../routes/visao-decisao';
// import VisaoGeralNew from '../../routes/visao-geral/2.0';
// import Importar from '../../routes/importar';
// import Importacoes from '../../routes/importacoes';
// import Calendario from '../../routes/calendario';
// import Sinalizadores from '../../routes/sinalizador';
// import Repetidos from '../../routes/repetidos';
// import Classificadores from '../../routes/classificadores';
// import Notificacoes from '../../routes/notificacoes';
// import Grupo from '../../routes/grupo-atributos';
// import Importacao from '../../routes/importacao-atualizacao';
// import Contatos from '../../routes/importacao-contatos';
// import Acoes from '../../routes/relatorio-acoes-usuario';
// import Inativacoes from '../../routes/relatorio-inativacoes';
// import Alteracoes from '../../routes/relatorio-alteracoes';
// import Usuarios from '../../routes/usuarios';
// import NovoUsu from '../../routes/usuarios/NovoUsu';

import { AppContextProvider } from "./context";
import { AppBar, Box, Grid, IconButton, Toolbar } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import BarChartIcon from "@mui/icons-material/BarChart";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PersonIcon from "@mui/icons-material/Person";
// import NotificationsProvider from './NotificationsProvider';
// import SocketProvider from './SocketProvider';

export default function App({ match, location }) {
  const [open, setOpen] = useState(false);
  const { usuario } = useContext(AuthContext);
  const history = useHistory();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // console.log("window.location.pathname", window.location.pathname);
  return (
    <AppContextProvider>
      <div>
        <CssBaseline />
        {/* <Header
          openMenu={handleDrawerOpen}
          abrir={open}
          userName={usuario}
          match={match}
        /> */}

        {/* <MenuSide closeMenu={handleDrawerClose} abrir={open} /> */}
      </div>
      {/* <Main style={{ marginBottom: 60, marginTop: 60 }} open={open}> */}
      {/* <SocketProvider /> */}
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/unidades`} />

        <Route
          path={`${match.url}/unidades`}
          render={(props) => (
            <Unidades
              {...props}
              // configHeader={configHeader}
              // refresh={refresh}
            />
          )}
        />
        <Route path={`${match.url}/ranking`} component={Ranking} />
        <Route path={`${match.url}/perfil`} component={Perfil} />
        <Route path={`${match.url}/escola`} component={Escola} />
        <Route
          path={`${match.url}/alteracaoSenha`}
          component={AlteracaoSenha}
        />
      </Switch>
      {/* </Main> */}
      {window.location.pathname !== "/app/unidades/acompanhamento" &&
        window.location.pathname !== "/app/unidades/unidade" &&
        window.location.pathname !== "/app/unidades/coordenacao" && (
          <div>
            <AppBar position="fixed" sx={{ top: "auto", bottom: 0 }}>
              <Toolbar style={{ background: "#3d79bd" }}>
                <Grid container>
                  <Grid style={{ textAlign: "center" }} xs={4}>
                    <IconButton
                      onClick={() => history.push(`${match.url}/unidades`)}
                      sx={{
                        display: "contents",
                        color: window.location.pathname.includes("unidades")
                          ? "#FCBE2D"
                          : "#E8E8E8",
                      }}
                    >
                      <CalendarMonthIcon fontSize="large" />
                      <p> Unidades</p>
                    </IconButton>
                  </Grid>
                  <Grid style={{ textAlign: "center" }} xs={4}>
                    <IconButton
                      onClick={() => history.push(`${match.url}/ranking`)}
                      sx={{
                        display: "contents",
                        color: window.location.pathname.includes("ranking")
                          ? "#FCBE2D"
                          : "#E8E8E8",
                      }}
                    >
                      <EmojiEventsIcon fontSize="large" />
                      <p>Ranking</p>
                    </IconButton>
                  </Grid>
                  <Grid style={{ textAlign: "center" }} xs={4}>
                    <IconButton
                      onClick={() => history.push(`${match.url}/perfil`)}
                      sx={{
                        display: "contents",
                        color: window.location.pathname.includes("perfil")
                          ? "#FCBE2D"
                          : "#E8E8E8",
                      }}
                    >
                      <PersonIcon fontSize="large" />
                      <p>Perfil</p>
                    </IconButton>
                  </Grid>
                </Grid>
              </Toolbar>
            </AppBar>
          </div>
        )}
    </AppContextProvider>
  );
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 250,
    }),
  })
);
